import { type FC } from "react";

import { DateFormatType, formatNullableDate } from "~/common/utils/DateFormatter";
import { WeightFormat } from "~/domains/product/components/WeightFormat";
import { type DeliveryEntryData } from "~/domains/orders/types/models";
import { useTranslation } from "react-i18next";
import { DeliveryHeader } from "~/features/orders/common/components/v2/OrderAndQuoteSharedStyles";
import { Param } from "~/features/orders/common/components/v2/Params";

interface DeliveryInformationProps {
  data: DeliveryEntryData;
  freightPayment: string;
}

const DeliveryInformationV2: FC<DeliveryInformationProps> = ({ data }) => {
  const { t } = useTranslation();
  return (
    <>
      <DeliveryHeader>
        <Param label={t("cartPage.shipmentDetails.deliveryNumber")} value={data.deliveryNumber} />
        <Param label={t("cartPage.shipmentDetails.shipmentTransportNumber")} value={data.transportNumber || "-"} />
        <Param
          label={t("cartPage.shipmentDetails.dateShipped")}
          value={formatNullableDate(data.actualGIDate, DateFormatType.DATE)}
        />
        <Param
          label={t("cartPage.shipmentDetails.totalWeight")}
          value={data.weight.value > 0 ? <WeightFormat weight={data.weight} /> : "-"}
        />
      </DeliveryHeader>
    </>
  );
};

export default DeliveryInformationV2;
